<template>
    <div class="cz__customizer">
        <product-views :controller="controller"></product-views>
        <sidebar :controller="controller" :visible="sidebarVisible"></sidebar>

        <button class="cz__menu" @click="toggleSidebar">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M436 124H12c-6.627 0-12-5.373-12-12V80c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12z"/></svg>
        </button>
    </div>
</template>

<style lang="less">
    .cz__customizer {
        position: absolute;

        left: 0;
        top: 0;

        width: 100%;
        height: 100%;

        font-family: 'Lato', Helvetica, Arial, sans-serif;

        * {
            box-sizing: border-box;
        }
    }

    .cz__menu {
        position: absolute;

        top: 0;
        right: 0;

        z-index: 1000;

        width: 46px;
        height: 46px;

        border: 1px solid #fff;
        background: #fff;

        svg {
            transform: scale(0.5, 0.5) translate(0px, 4px);
        }

        @media (min-width: 768px) {
            display: none;
        }
    }

    // Common styles.

    .cz__button {
        display: inline-block;

        border: 0;
        border-radius: 0;

        height: 32px;
        line-height: 32px;

        font-size: 12px;

        background: #474747;
        color: #fff;

        text-align: center;
        text-transform: uppercase;

        cursor: pointer;
    }
</style>

<script>
    import Vue from 'vue';
    import PortalVue from 'portal-vue';

    import Sidebar from './Sidebar';
    import ProductViews from './ProductViews';

    import EventBus from './eventbus';

    Vue.use(PortalVue);

    export default {
        props: {
            options: Object,
        },
        data() {
            // Expected blueprint URL.
            let blueprintUrl = 'https://api.customizer.drivecommerce.com/api/v1/blueprint/' + this.options.product + '/_/_/';

            if (this.options.apiKey) {
                blueprintUrl += '?apikey=' + this.options.apiKey;
            }

            return {
                blueprintUrl,

                controller: null,
                blueprint: null,
                state: null,
                groups: null,
                sidebarVisible: false,
            };
        },
        mounted() {
            // Resize customizer when the screen size changes.
            window.addEventListener('resize', () => this.resize());
            this.resize();

            // Listen to add to cart events.
            EventBus.$on('addToCart', this.added);

            // Load the controller pieces (blueprint, etc) when the app is instantiated.
            this.load();
        },
        methods: {
            // Resizes the customizer UX to match screen dimensions.
            resize() {
                // This also takes care of iOS not including address or status bars into 100vh metrics.
                document.body.style.height = window.innerHeight + 'px';
            },

            // Loads the customizer controller.
            load() {
                this.controller = new window.DriveCustomizer.Controller({
                    blueprint: this.blueprintUrl,
                });

                this.controller.load();
            },

            // Toggle sidebar on mobile devices.
            toggleSidebar() {
                this.sidebarVisible = !this.sidebarVisible;
            },

            // Handles add to cart event.
            added(recipe) {
                if (this.options.on && this.options.on.addToCart) {
                    this.options.on.addToCart(recipe);
                }
            },
        },
        components: {
            Sidebar,
            ProductViews,
        },
    };
</script>